module.exports = __webpack_public_path__ + "static/media/9-IMG_6698.6f8fec52.JPG";